import React from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";



const CSSLesson5 = () => {
  return (
    <HTMLCourseNavProvider>
      <div className="container">
      <div className="row">
      <div>
        <SideBar />
      </div>

    <h3><strong>Latest CSS3 Features</strong></h3>
    <p><b>CSS3</b> stands for Cascading Style Sheet level 3, which is the advanced version of CSS.
    It is used for structuring, styling, and formatting web pages. Several new features have been added to CSS3 and is supported by all modern web browsers.
    One of the most important feature of CSS3 is the splitting of CSS standards into separate modules. This makes it easier to learn and use.
    </p>
    <div className="alert alert-secondary" role="alert">
    <p><strong>Background style properties:</strong> New features like background-clip, size, style, and origin properties have been added to CSS3.</p>
    <p><strong>Pseudo-elements:</strong> Plenty of new pseudo-elements have been added to CSS3 to give easy styling in depth. Even a new convention of double colons :: is also added.</p>
    <p><strong>Border Style:</strong> The latest CSS3 also has new border styling features like border-radius, image-slice, image-source, and values for “width stretch”, etc.</p>
    <p><strong>CSS Selectors:</strong> CSS3 selectors are much advanced in comparison to simple selectors offered by CSS, and are termed as a sequence of easy to use and simple selectors.</p><br/>
    </div>

    </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson5;
